function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import flatten from 'ramda/src/flatten';
import pluck from 'ramda/src/pluck';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { ShippingMethodsSelector } from 'invision-core/src/components/metadata/shippingMethods/shipping.methods.selectors';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { BILLER_RULE_INSTANCE_TYPE } from '../../customercare.constants';
import { CHARGE_TIMING, FULL_CART_COLUMNS, OFFER_ORDER_QUOTE_GROUPS } from '../constants/wizard.constants';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../constants/common.constants';
import { OfferingOrderQuoteSelector } from './offering.order.selectors';
import { ExistingItemsPlaceholderName, ExistingServicesPlaceholderName, getChargeAmount, getItemQuote, GUIDServiceIdentifierValue, reorderFullCartItems } from '../helpers/full.cart.selectors.helpers';
import CustomerCareLocale from './../../locales/keys';
import { getFormattedServiceAttributeValue } from './services.list.selectors.helper';
var TaxQuoteSelector = createImmutableSelector([OfferingOrderQuoteSelector], function (offeringOrderQuote) {
  return offeringOrderQuote.TaxQuote || EMPTY_OBJECT;
});
var FeeQuoteSelector = createImmutableSelector([OfferingOrderQuoteSelector], function (offeringOrderQuote) {
  return offeringOrderQuote.FeeQuote || EMPTY_OBJECT;
});
var OfferingQuotesSelector = createImmutableSelector([OfferingOrderQuoteSelector], function (offeringOrderQuote) {
  return offeringOrderQuote.OfferingQuotes || EMPTY_ARRAY;
});
var OfferingOrderQuoteTotalsSelector = createImmutableSelector([OfferingOrderQuoteSelector], function (offeringOrderQuote) {
  return offeringOrderQuote.OfferingOrderQuoteTotals || EMPTY_ARRAY;
});
var BillerRuleConfigurationsSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.CustomBillerRuleConfiguration), MetadataCodeTypeSelector(CODES.EntitlementBillerRuleConfiguration), MetadataCodeTypeSelector(CODES.FinanceBillerRuleConfiguration), MetadataCodeTypeSelector(CODES.OneTimeBillerRuleConfiguration), MetadataCodeTypeSelector(CODES.RecurringBillerRuleConfiguration), MetadataCodeTypeSelector(CODES.UsageBillerRuleConfiguration)], function (customerBrcs, entitlementBrcs, financeBrcs, OneTimeBrcs, recurringBrcs, usageBrcs) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BILLER_RULE_INSTANCE_TYPE.CUSTOM, customerBrcs), BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT, entitlementBrcs), BILLER_RULE_INSTANCE_TYPE.FINANCE, financeBrcs), BILLER_RULE_INSTANCE_TYPE.ONETIME, OneTimeBrcs), BILLER_RULE_INSTANCE_TYPE.RECURRING, recurringBrcs), BILLER_RULE_INSTANCE_TYPE.USAGE, usageBrcs);
});
export var FullCartOfferingOrderQuoteTotalSelector = createImmutableSelector([OfferingOrderQuoteTotalsSelector], function (offeringOrderQuoteTotals) {
  return {
    dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, offeringOrderQuoteTotals),
    dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, offeringOrderQuoteTotals),
    dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, offeringOrderQuoteTotals),
    dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, offeringOrderQuoteTotals),
    dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, offeringOrderQuoteTotals)
  };
});
export var FullCartOfferingOrderTaxQuoteSelector = createImmutableSelector([TaxQuoteSelector], function (taxQuote) {
  return {
    dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, taxQuote.TaxQuoteTotals),
    dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, taxQuote.TaxQuoteTotals),
    dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, taxQuote.TaxQuoteTotals),
    dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, taxQuote.TaxQuoteTotals),
    dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, taxQuote.TaxQuoteTotals),
    taxItemQuotes: (taxQuote.TaxItemQuotes || []).map(function (taxItemQuote) {
      return {
        name: taxItemQuote.Name,
        dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, taxItemQuote.TaxItemQuoteTotals),
        dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, taxItemQuote.TaxItemQuoteTotals),
        dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, taxItemQuote.TaxItemQuoteTotals),
        dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, taxQuote.TaxQuoteTotals),
        dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, taxQuote.TaxQuoteTotals)
      };
    })
  };
});
export var FullCartOfferingOrderFeeQuoteSelector = createImmutableSelector([FeeQuoteSelector], function (feeQuote) {
  return {
    dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, feeQuote.FeeQuoteTotals),
    dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, feeQuote.FeeQuoteTotals),
    dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, feeQuote.FeeQuoteTotals),
    dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, feeQuote.FeeQuoteTotals),
    dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, feeQuote.FeeQuoteTotals),
    feeItemQuotes: (feeQuote.FeeItemQuotes || []).map(function (feeItemQuote) {
      return {
        name: feeItemQuote.Name,
        dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, feeItemQuote.FeeItemQuoteTotals),
        dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, feeItemQuote.FeeItemQuoteTotals),
        dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, feeItemQuote.FeeItemQuoteTotals),
        dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, feeItemQuote.FeeItemQuoteTotals),
        dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, feeItemQuote.FeeItemQuoteTotals)
      };
    })
  };
});
export var FullCartOfferingOrderQuotesSelector = createImmutableSelector([OfferingQuotesSelector, BillerRuleConfigurationsSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (offeringQuotes, billerRuleConfigurations, serviceAttributes, regularExpressions) {
  var fullCartItems = _toConsumableArray(offeringQuotes).sort(function (offer1, offer2) {
    return offer1.OfferingInstanceId - offer2.OfferingInstanceId;
  }).map(function (OfferingQuote) {
    var additionalItems = [];
    if (OfferingQuote.ServiceQuotes) {
      var otherServices = OfferingQuote.ServiceQuotes.filter(function (serviceQuote) {
        return serviceQuote.ServiceIdentifierValue === GUIDServiceIdentifierValue;
      });
      additionalItems = flatten(pluck('ItemQuotes', otherServices)).map(function (itemQuote) {
        return getItemQuote(itemQuote, billerRuleConfigurations);
      }).filter(function (item) {
        return item;
      });
    }
    var serviceQuotesWithoutOtherServices = (OfferingQuote.ServiceQuotes || []).filter(function (quote) {
      return quote.ServiceIdentifierValue && quote.ServiceIdentifierValue !== GUIDServiceIdentifierValue;
    });
    var serviceQuotesWithoutExistingServices = (OfferingQuote.ServiceQuotes || []).filter(function (service) {
      return service.ServiceIdentifierValue && service.ServiceIdentifierValue !== ExistingServicesPlaceholderName || !service.ServiceIdentifierValue;
    });
    var serviceQuotes = serviceQuotesWithoutExistingServices.filter(function (ServiceQuote) {
      return ServiceQuote.ServiceIdentifierValue && ServiceQuote.ServiceIdentifierValue !== GUIDServiceIdentifierValue || serviceQuotesWithoutExistingServices.length === 1;
    }).map(function (ServiceQuote) {
      var firstItemWithServiceIdentifier = (OfferingQuote.ServiceQuotes || []).map(function (serviceQuote) {
        return serviceQuote.ItemQuotes.find(function (ItemQuote) {
          return ItemQuote.ParentServiceIdentifier && ItemQuote.ParentServiceIdentifier.Value === ServiceQuote.ServiceIdentifierValue;
        });
      }).find(function (item) {
        return item;
      });
      var itemQuotes = ServiceQuote.ItemQuotes.length ? ServiceQuote.ItemQuotes.map(function (ItemQuote) {
        return getItemQuote(ItemQuote, billerRuleConfigurations);
      }) : [];
      return {
        serviceIdentifierValue: firstItemWithServiceIdentifier && getFormattedServiceAttributeValue(firstItemWithServiceIdentifier.ParentServiceIdentifier.ServiceAttributeId, firstItemWithServiceIdentifier.ParentServiceIdentifier.Value, serviceAttributes, regularExpressions),
        dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, ServiceQuote.Totals),
        dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, ServiceQuote.Totals),
        dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, ServiceQuote.Totals),
        dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, ServiceQuote.Totals),
        dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, ServiceQuote.Totals),
        itemQuotes: reorderFullCartItems(itemQuotes)
      };
    }).filter(function (serviceQuote) {
      return serviceQuote.itemQuotes.length;
    });
    var isExistingOfferPlaceHolder = OfferingQuote.OfferName === ExistingItemsPlaceholderName;
    return {
      offerName: isExistingOfferPlaceHolder ? i18n.translate(CustomerCareLocale.FULL_CART.EXISTING_ITEMS) : OfferingQuote.OfferName,
      isPlaceHolderForExistingItems: isExistingOfferPlaceHolder,
      offeringInstanceId: OfferingQuote.OfferingInstanceId,
      offeringOrderQuoteGroup: OfferingQuote.OfferingOrderQuoteGroup,
      dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, OfferingQuote.OfferingQuoteTotals),
      dueNextInvoice: getChargeAmount(CHARGE_TIMING.BILL_CYCLE, OfferingQuote.OfferingQuoteTotals),
      dueRecurring: getChargeAmount(CHARGE_TIMING.DUE_RECURRING, OfferingQuote.OfferingQuoteTotals),
      dueOnActivation: getChargeAmount(CHARGE_TIMING.DUE_ON_ACTIVATION, OfferingQuote.OfferingQuoteTotals),
      dueOnFirstUse: getChargeAmount(CHARGE_TIMING.DUE_ON_FIRST_USE, OfferingQuote.OfferingQuoteTotals),
      servicesCount: serviceQuotes.length,
      serviceQuotes: additionalItems.length && serviceQuotesWithoutOtherServices.length ? [].concat(_toConsumableArray(serviceQuotes), [{
        isAdditionalProductsSection: true,
        itemQuotes: additionalItems
      }]) : serviceQuotes
    };
  });
  var currentItems = fullCartItems.filter(function (item) {
    return item.offeringOrderQuoteGroup === OFFER_ORDER_QUOTE_GROUPS.CURRENT;
  });
  var existingItemHeader = fullCartItems.filter(function (item) {
    return item.offeringOrderQuoteGroup === OFFER_ORDER_QUOTE_GROUPS.EXISTING && item.isPlaceHolderForExistingItems;
  });
  var existingItems = fullCartItems.filter(function (item) {
    return item.offeringOrderQuoteGroup === OFFER_ORDER_QUOTE_GROUPS.EXISTING && !item.isPlaceHolderForExistingItems;
  });
  return [].concat(_toConsumableArray(currentItems), _toConsumableArray(existingItemHeader), _toConsumableArray(existingItems));
});
export var ShowHideFullCartColumnsSelector = createImmutableSelector([FullCartOfferingOrderQuoteTotalSelector, FullCartOfferingOrderTaxQuoteSelector, FullCartOfferingOrderQuotesSelector], function (offeringOrderQuoteTotal, offeringOrderTaxQuote, offeringOrderQuotes) {
  var result = {
    showDueToday: false,
    showDueNextInvoice: false,
    showDueRecurring: false,
    showDueOnActivation: false,
    showDueOnFirstUse: false
  };
  result.showDueToday = getColumnShowHideStatus(offeringOrderQuoteTotal, offeringOrderTaxQuote, offeringOrderQuotes, FULL_CART_COLUMNS.DUE_TODAY);
  result.showDueNextInvoice = getColumnShowHideStatus(offeringOrderQuoteTotal, offeringOrderTaxQuote, offeringOrderQuotes, FULL_CART_COLUMNS.DUE_NEXT_INVOICE);
  result.showDueRecurring = getColumnShowHideStatus(offeringOrderQuoteTotal, offeringOrderTaxQuote, offeringOrderQuotes, FULL_CART_COLUMNS.DUE_RECURRING);
  result.showDueOnActivation = getColumnShowHideStatus(offeringOrderQuoteTotal, offeringOrderTaxQuote, offeringOrderQuotes, FULL_CART_COLUMNS.DUE_ON_ACTIVATION);
  result.showDueOnFirstUse = getColumnShowHideStatus(offeringOrderQuoteTotal, offeringOrderTaxQuote, offeringOrderQuotes, FULL_CART_COLUMNS.DUE_ON_FIRST_USE);
  return result;
});
function getColumnShowHideStatus(offeringOrderQuoteTotal, offeringOrderTaxQuote, offeringOrderQuotes, key) {
  if (offeringOrderQuoteTotal[key] || offeringOrderQuoteTotal[key] === 0 || offeringOrderTaxQuote[key] || offeringOrderTaxQuote[key] === 0) {
    return true;
  }
  return offeringOrderQuotes.some(function (offeringOrderQuotesItem) {
    if (offeringOrderQuotesItem[key] || offeringOrderQuotesItem[key] === 0) {
      return true;
    } else {
      if (offeringOrderQuotesItem.serviceQuotes && offeringOrderQuotesItem.serviceQuotes.length) {
        return offeringOrderQuotesItem.serviceQuotes.some(function (serviceQuote) {
          if (serviceQuote[key] || serviceQuote[key] === 0) {
            return true;
          } else {
            return serviceQuote.itemQuotes.some(function (itemQuote) {
              if (itemQuote.chargeQuotes && itemQuote.chargeQuotes.length) {
                return itemQuote.chargeQuotes.some(function (chargeQuote) {
                  if (chargeQuote[key] || chargeQuote[key] === 0) {
                    return true;
                  }
                });
              }
            });
          }
        });
      }
    }
  });
}
var ShippingQuoteSelector = createImmutableSelector([OfferingOrderQuoteSelector], function (offeringOrderQuote) {
  return offeringOrderQuote.ShippingQuote || EMPTY_OBJECT;
});
var getMethodName = function getMethodName(methodId, shippingMethods) {
  var selectedMethod = shippingMethods.find(function (method) {
    return method.Id === convertStringToNumber(methodId);
  });
  return selectedMethod.Name;
};
export var FullCartOfferingOrderShippingQuoteSelector = createImmutableSelector([ShippingQuoteSelector, ShippingMethodsSelector], function (shippingQuote, shippingMethods) {
  return {
    dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, shippingQuote.ShippingQuoteTotals),
    //Shipping will only have due today charge, the following properties are added to align the full cart modal.
    dueNextInvoice: null,
    dueOnActivation: null,
    dueOnFirstUse: null,
    dueRecurring: null,
    shippingItemQuotes: (shippingQuote.ShippingItemQuotes || []).map(function (item) {
      return {
        name: getMethodName(item.Name, shippingMethods),
        dueToday: getChargeAmount(CHARGE_TIMING.DUE_TODAY, item.ShippingItemQuoteTotals),
        dueNextInvoice: null,
        dueRecurring: null,
        dueOnActivation: null,
        dueOnFirstUse: null
      };
    })
  };
});